module.exports = __webpack_public_path__ + "img/noContent.1c3c683c.svg";